import { Injectable }              from '@angular/core';
import { Organization }            from '@app/modules/organization/models/organization.model';
import { OrganizationHelperCheck } from '@app/modules/organization/services/helpers';
import { OrganizationService }     from '@app/modules/organization/services/organization.service';
import {
	OrganizationDTO,
	OrganizationUpdateBodyDTO
}                                  from '@openApiGenerated/admin-api';
import { OrganizationBodyDTO }     from '@openApiGenerated/management-api';

/*
 * Provides public utils methods all returning a boolean.
 */
@Injectable( { providedIn: 'root' } )
export class OrganizationHelperCheckService {

	organizationServiceInstance: OrganizationService;

	constructor() {}

	public isNaturalPerson( organization: Organization ): boolean {
		return OrganizationHelperCheck.isNaturalPerson( organization );
	}

	public isNaturalPersonDto( organizationDto: OrganizationDTO | OrganizationBodyDTO | OrganizationUpdateBodyDTO ): boolean {
		return OrganizationHelperCheck.isNaturalPersonDto( organizationDto );
	}
}
